import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  TextInput, required,
} from "react-admin";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";

export const NeedCategoryList = (props) => (

  <List {...props} sort={{ field: 'updatedAt', order: 'DESC' }}>
    <Datagrid rowClick="show">
      {/* <DateField  locales={"fa-IR"} source="createdAt" /> */}
      <TextField source="title" />
    </Datagrid>
  </List>
);

export const NeedCategoryEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="title" validate={required()} />
  </EditView>
);

export const NeedCategoryShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" />
    </SimpleShowLayout>
  </ShowView>
);

export const NeedCategoryCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title" label="عنوان" />
  </CreateView>
);
